import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { WithLoaderDirective } from './with-loader.directive';
import { WithLoaderComponent } from './with-loader.component';
import { Material } from '../../_shared/material.module';

@NgModule({
    imports: [
        CommonModule,
        Material
    ],
    exports: [
        WithLoaderDirective,
        WithLoaderComponent
    ],
    entryComponents: [
      WithLoaderComponent
    ],
    declarations: [
      WithLoaderDirective,
        WithLoaderComponent
    ]
})
export class WithLoaderModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: WithLoaderModule
        };
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/with-loader/with-loader.module.ts